(function (angular, app) {
   "use strict";
    
   // Heading
   angular.module(app.modules.ui.name)
      .directive(app.modules.ui.directives.footing, FootingDirective); 
      
   FootingDirective.$inject = [
      app.modules.common.constants.appsettings
   ];
   
   function FootingDirective(appSettings) {
      return {
         restrict : "E"
         , templateUrl : "app/ui/directives/footing.html"
         , link: function (scope, element, attrs) {
            
            scope.Version = appSettings.version;

            
         }
      }
   }


}(angular, app));
